module.exports = __webpack_public_path__ + "static/media/SheJiao2.a80be540.png";